import React, { ReactElement } from 'react';
import { ZCDDoughnutChart, ZCDDataVisualizationColor } from '@zencity/common-ui';
import { SortedTopConcern } from 'screens/WidgetGenerator/utils/answerClassificationBreakdown';

const MAX_SUB_TOPICS_ITEMS = 5;

interface Props {
  concern: SortedTopConcern;
  colors: (keyof typeof ZCDDataVisualizationColor)[];
}

export const TopConcernBreakdown = (props: Props): ReactElement => {
  const { concern, colors } = props;

  const titleDataItem = {
    label: concern.label,
    value: concern.total,
  };

  const labels = concern.subTopics.slice(0, MAX_SUB_TOPICS_ITEMS).map((subTopic) => subTopic.label);
  const subTopicsDataset = {
    // eslint-disable-next-line id-denylist
    data: concern.subTopics.slice(0, MAX_SUB_TOPICS_ITEMS).map((subTopic, index) => ({
      backgroundColor: colors[index],
      label: subTopic.label,
      value: subTopic.total,
    })),
  };

  return (
    <ZCDDoughnutChart
      chartWidth={120}
      legendPosition="right"
      titleDataItem={titleDataItem}
      chartDataset={subTopicsDataset}
      labels={labels}
    />
  );
};
